define(['./each', './is-undefined'], function(each, isUndefined) {
    'use strict';
    var parse = function(expression) {
        var parts = expression.split('.'),
            body = [];
        this.parts = parts;

        body.push('var curr = obj;');
        each(parts, function(part) {
            body.push('if (!curr) return curr;');
            body.push('curr = curr["' + part + '"];');
        });

        body.push('return curr;');

        var ret = new Function('obj', body.join(''));
        ret.assign = function(obj, value) {
            if (!obj) {
                throw new Error('util.parse.assign expects its first argument to be an object');
            }

            var curr = obj,
                prevCurr, currPart;
            each(parts, function(part) {
                currPart = part;
                prevCurr = curr;
                curr = curr[part];
                if (isUndefined(curr) || curr === null) {
                    prevCurr[part] = {};
                    curr = prevCurr[part];
                }
            });

            if (!prevCurr || !currPart) {
                return;
            }

            prevCurr[currPart] = value;
        };

        return ret;
    };

    return parse;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/parse.js
 ** module id = 21
 ** module chunks = 0
 **/